"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  SelectField: true
};
exports.default = exports.SelectField = void 0;
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _useOverflowDetector = require("../utils/useOverflowDetector");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _useFitToWidth = require("../utils/useFitToWidth");
var _FormField = require("./_FormField");
var _SelectField = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SelectField.css") : void 0);
var _SelectField2 = require("./_SelectField.types");
Object.keys(_SelectField2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SelectField2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SelectField2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-select-field';
const SelectField = exports.SelectField = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(SelectField, _props)) : _props;
  const {
      className,
      controlProps,
      disabled,
      id,
      inputProps,
      inputRef,
      label,
      labelProps,
      onBlur,
      onClick,
      onFocus,
      placeholder,
      readOnly,
      required,
      value,
      isRenderedValue,
      emptyAriaLabel,
      matchInactiveValueWidth
    } = props,
    formFieldProps = __rest(props, ["className", "controlProps", "disabled", "id", "inputProps", "inputRef", "label", "labelProps", "onBlur", "onClick", "onFocus", "placeholder", "readOnly", "required", "value", "isRenderedValue", "emptyAriaLabel", "matchInactiveValueWidth"]);
  const classnames = _bind.default.bind(_SelectField.default);
  const classes = classnames(CSS_BLOCK, className, {
    [`${CSS_BLOCK}--read-only`]: readOnly,
    [`${CSS_BLOCK}--custom-input-value`]: isRenderedValue
  });
  const internalValueRef = (0, _react.useRef)(null);
  const mouseDownPositionRef = (0, _react.useRef)(null);
  const isCopyingTextRef = (0, _react.useRef)(false);
  let selectId = (0, _useUniqueId.default)();
  if (id) {
    selectId = id;
  }
  const labelId = (labelProps === null || labelProps === void 0 ? void 0 : labelProps.id) || `label-${selectId}`;
  let inputId = (0, _useUniqueId.default)();
  if (inputProps === null || inputProps === void 0 ? void 0 : inputProps.id) {
    inputId = inputProps.id;
  }
  const handleBlur = e => {
    if (!disabled) {
      onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    }
  };
  const handleClick = e => {
    if (!disabled) {
      if (isCopyingTextRef.current) {
        isCopyingTextRef.current = false;
        return;
      }
      onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }
  };
  const handleFocus = e => {
    var _a;
    if (disabled) {
      (_a = internalValueRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    } else {
      onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    }
  };
  const {
    hasOverflow
  } = (0, _useOverflowDetector.useOverflowDetector)(internalValueRef, [value]);
  const isPlaceholderValue = placeholder && !value && !readOnly && !disabled;
  const {
    measurementNode
  } = (0, _useFitToWidth.useFitToWidth)({
    toMeasure: value,
    targetToChangeRef: internalValueRef,
    matchCondition: matchInactiveValueWidth && (disabled || readOnly),
    measurementNodeClassName: classnames(`${CSS_BLOCK}__inactive-text-measurement`),
    // Add a buffer to prevent text from being too tight
    // 2px margin + 8px padding on each side = 20px buffer
    widthBuffer: 20
  });
  const renderInput = _a => {
    var _b;
    var {
        inputClassName,
        isFocused
      } = _a,
      attributes = __rest(_a, ["inputClassName", "isFocused"]);
    const inputClasses = classnames(inputClassName, `${CSS_BLOCK}__input`, inputProps === null || inputProps === void 0 ? void 0 : inputProps.className, {
      [`${CSS_BLOCK}__input--placeholder`]: isPlaceholderValue,
      [`${CSS_BLOCK}__input--inactive`]: disabled || readOnly
    });
    const getInputContent = () => {
      if (value) {
        return value;
      }
      if (placeholder && !readOnly && !disabled) {
        return placeholder;
      }
      return undefined;
    };
    const showOverflowTitle = !isRenderedValue && hasOverflow && (!isFocused || readOnly || disabled);
    const overflowTitle = showOverflowTitle ? value || ((_b = internalValueRef.current) === null || _b === void 0 ? void 0 : _b.value) || placeholder : undefined;
    const inputMergedRef = (0, _reactMergeRefs.default)([internalValueRef, inputRef]);
    if (emptyAriaLabel) {
      return /*#__PURE__*/_react.default.createElement("span", Object.assign({}, inputProps, {
        className: inputClasses,
        id: inputId,
        ref: inputMergedRef
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: classnames(`${CSS_BLOCK}__empty-option`)
      }, emptyAriaLabel));
    }
    const commonProps = Object.assign(Object.assign({}, attributes), {
      'aria-labelledby': labelId,
      type: 'text',
      title: overflowTitle,
      className: inputClasses,
      value: getInputContent(),
      id: inputId,
      ref: inputMergedRef
    });
    if (disabled || readOnly) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, measurementNode, /*#__PURE__*/_react.default.createElement("input", Object.assign({}, inputProps, {
        disabled: disabled,
        readOnly: readOnly
      }, commonProps)));
    }
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      _react.default.createElement("span", Object.assign({
        title: overflowTitle,
        role: "presentation" // presentation role allows us to add
      }, inputProps, attributes, {
        onMouseDown: (0, _chainFunction.default)(inputProps === null || inputProps === void 0 ? void 0 : inputProps.onMouseDown, event => {
          mouseDownPositionRef.current = event.clientX;
        }),
        onMouseUp: (0, _chainFunction.default)(inputProps === null || inputProps === void 0 ? void 0 : inputProps.onMouseUp, event => {
          var _a, _b;
          if (mouseDownPositionRef.current !== null && mouseDownPositionRef.current !== event.clientX && ((_b = (_a = window.getSelection) === null || _a === void 0 ? void 0 : _a.call(window)) === null || _b === void 0 ? void 0 : _b.toString())) {
            isCopyingTextRef.current = true;
          }
          mouseDownPositionRef.current = null;
        }),
        onBlur: handleBlur,
        onFocus: handleFocus,
        className: inputClasses,
        id: inputId,
        ref: inputMergedRef,
        tabIndex: -1
      }), getInputContent())
    );
  };
  return /*#__PURE__*/_react.default.createElement(_FormField.FormField, Object.assign({}, formFieldProps, {
    className: classes,
    controlProps: Object.assign(Object.assign({}, controlProps), {
      onClick: handleClick,
      'aria-labelledby': disabled || readOnly ? undefined : labelId
    }),
    disabled: disabled,
    id: selectId,
    inputId: inputId,
    label: label,
    labelProps: Object.assign(Object.assign({}, labelProps), {
      id: labelId
    }),
    readOnly: readOnly,
    ref: ref,
    renderInput: renderInput,
    required: required,
    canTruncate: !isRenderedValue && hasOverflow,
    noTruncationOnFocus: true,
    describeControl: !readOnly && !disabled
  }));
});
SelectField.displayName = 'SelectField';
var _default = exports.default = SelectField;